export class LoginInfo {
  email?: string;
  senha?: string;
}
